import { useCallback, useEffect, useState } from "react";
import Header from "../../Components/Header";
import SidePanel from "../../Components/SidePanel";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Components/Loader";
import Search from "../../Components/Search";
import CreateCampus from "./CreateCampus";
import CampusTable from "./CampusTable";
import CampusFilter from "./CampusFilter";
import {
  CAMPUS_DELETE_LIST,
  CAMPUS_DELETE_LIST_RESET,
  CAMPUS_LISTS,
} from "../../Actions/campusAction";

export default function Index() {
  const [hideSidepanel, setHideSidePanel] = useState(true);
  const [FormOpener, setFormOpener] = useState(false);
  const [EditFormOpener, setEditFormOpener] = useState(false);
  const [CampusLists, setCampusLists] = useState([]);
  const [Alert, setAlert] = useState(false);
  const [CampusID, setCampusID] = useState("");
  const [Campus_Search_Name, setCampus_Search_Name] = useState("");

  const { Campus_List_Loading, Campus_Lists, Campus_List_Error } = useSelector(
    (state) => state.CAMPUS_LIST_REDUCER
  );

  const { Delete_Campus_Success, Delete_Campus_Error } = useSelector(
    (state) => state.CAMPUS_DELETE_REDUCER
  );
  const dispatch = useDispatch();

  const handleHide = (e) => {
    e.preventDefault();
    setHideSidePanel(!hideSidepanel);
  };

  /* handle Searching according to University name start  */
  const handleSearch_data = (e) => {
    if (e.target.value === "" || e.target.value === null) {
      setCampusLists(Campus_Lists);
    } else {
      setCampus_Search_Name(e.target.value);
    }
  };

  const handleCampusSearch_Data = async () => {
    const new_Campus_Data = CampusLists?.filter((el) =>
      el.Campus_Name.toLowerCase().includes(Campus_Search_Name.toLowerCase())
    );
    setCampusLists(new_Campus_Data);
  };

  const handleCampusSearching = (e) => {
    e.preventDefault();
    handleCampusSearch_Data();
  };
  const handleKey = (e) => {
    if (e.key === "Enter") {
      handleCampusSearch_Data();
    }
  };
  /* handle Searching according to University name End  */
  const handleFormClose = () => {
    setFormOpener(!FormOpener);
  };

  const handleEditorForm = () => {
    setEditFormOpener(!EditFormOpener);
  };
  const handleEditCampusData = (Id) => {
    setCampusID(Id);
    handleEditorForm();
  };

  const CampusLists_Get_Req = useCallback(() => {
    dispatch(CAMPUS_LISTS());
  },[dispatch]);

  const handleDeleteCampus = (ID) => {
    dispatch(CAMPUS_DELETE_LIST(ID));
  };

  useEffect(() => {
    CampusLists_Get_Req();
  }, [Delete_Campus_Success,CampusLists_Get_Req]);

  useEffect(() => {
    setCampusLists(Campus_Lists);
  }, [Campus_Lists]);

  useEffect(() => {
    if (Delete_Campus_Success) {
      setAlert(Delete_Campus_Success);
    }
    if (Delete_Campus_Error) {
      setAlert(Delete_Campus_Error);
    }

    if (Delete_Campus_Error || Delete_Campus_Success) {
      setTimeout(() => {
        setAlert(false);
        dispatch(CAMPUS_DELETE_LIST_RESET());
      }, 2000);
    }
  }, [Delete_Campus_Success, Delete_Campus_Error,dispatch]);

  return (
    <>
      <Header Page={"Campus"} handleHide={handleHide} />
      {/*<!-- top-right search bar -->*/}
      <SidePanel handleHide={handleHide} hide={hideSidepanel} />
      {/*<!-- Pushable content along with off-canvas opener. -->*/}
      <div className="bs-offset-main bs-canvas-anim">
        <div className="content-body">
          {/*<!--Body-content-->*/}
          <div className="container-fluid">
            <div className="heading-title">
              <div className="row">
                <div className="col-md-12">
                  <div className="home-table-search">
                    {/* University Web Details Search  */}
                    <Search
                      handleSearch={handleSearch_data}
                      handleSearching={handleCampusSearching}
                      handleKey={handleKey}
                      SearchData={Campus_Search_Name}
                      placeholder={"Search Campus"}
                    />

                    <div className="right-click Create-btn">
                      <a
                        href="#"
                        className="btn create-contact"
                        onClick={() => handleFormClose()}>
                        Create Campus
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {Alert && (
              <div className="side_drawer">
                <div className={Delete_Campus_Success ? "Alert2" : "Alert3"}>
                  <span onClick={() => setAlert(false)} className="close">
                    &times;
                  </span>
                  <p>{Alert}</p>
                </div>
              </div>
            )}

            <div className="inner-body">
              <div className="row">
                <div className="col-md-3 col-lg-2">
                  <div className="filter-in-mob-view text-right">
                    <input
                      type="text"
                      name="search"
                      placeholder="Search Contacts..."
                    />
                    <i className="fas fa-filter mob-nav-open"></i>
                  </div>
                  {/*<!-- /filter-in-mob-view -->*/}
                  <CampusFilter />
                </div>
                {/*<!-- University web Details Table -->*/}
                {}
                {Campus_List_Loading ? (
                  <div>
                    <Loader />
                  </div>
                ) : Campus_List_Error ? (
                  <div>
                    <img
                      className="No_data"
                      src="./assets/img/NoRecord.png"
                      alt="data_notfound"
                    />
                  </div>
                ) : (
                  <CampusTable
                    setCampusLists={setCampusLists}
                    handleEditCampusData={handleEditCampusData}
                    handleDeleteCampus={handleDeleteCampus}
                    CampusLists_Get_Req={CampusLists_Get_Req}
                    CampusLists={CampusLists}
                    LOADING={Campus_List_Loading}
                  />
                )}
              </div>
            </div>
            <CreateCampus
              CampusID={CampusID}
              CampusLists_Get_Req={CampusLists_Get_Req}
              handleEditorForm={handleEditorForm}
              EditFormOpener={EditFormOpener}
              FormOpener={FormOpener}
              handleFormClose={handleFormClose}
            />
            {/*<!--/overlay-Create-contact-->*/}
          </div>
        </div>
      </div>
    </>
  );
}
